var $8eba2345a6c506af$exports = {};
class $8eba2345a6c506af$var$HtmlTemplate extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    static get observedAttributes() {
        return [
            "contents"
        ];
    }
    attributeChangedCallback(name, _, newValue) {
        if (name == "contents") this.shadowRoot.innerHTML = newValue;
    }
}
window.customElements.define("html-template", $8eba2345a6c506af$var$HtmlTemplate);


//# sourceMappingURL=provider-portal.4bfdff58.js.map
